import React from "react";
import { Link } from "react-router-dom";

function OpenAccount() {
  return (
    <section className="container cta-section">
      <div className="section-card section-cta text-center">
        <h1>Open a Zerodha account</h1>
        <p>
          Modern platforms and apps, ₹0 investments, and flat ₹20 intraday and
          F&O trades.
        </p>
        <Link to="/signup" className="btn btn-primary">
          Sign up now
        </Link>
      </div>
    </section>
  );
}

export default OpenAccount;
